import { render, staticRenderFns } from "./PlateView.vue?vue&type=template&id=fa9ba236&"
import script from "./PlateView.vue?vue&type=script&lang=js&"
export * from "./PlateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports